/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class FinopsAssessmentTriggerRequest {
    getFixupPrototypeFunction() { return FinopsAssessmentTriggerRequest.fixupPrototype; }

    static newInstance(model: Partial<FinopsAssessmentTriggerRequest>): FinopsAssessmentTriggerRequest {
        let obj = Object.assign(new FinopsAssessmentTriggerRequest(), model);
        FinopsAssessmentTriggerRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<FinopsAssessmentTriggerRequest>): FinopsAssessmentTriggerRequest {
        if (!model) return null;
        return FinopsAssessmentTriggerRequest.newInstance(<FinopsAssessmentTriggerRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: FinopsAssessmentTriggerRequest) {
        if (!obj) return;

        models.FinopsAssessmentTriggerRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: FinopsAssessmentTriggerRequest): boolean {
        Object.setPrototypeOf(obj, FinopsAssessmentTriggerRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Action that needs to be performed
     */
    action: models.AssessmentAction;

    /**
     * Category of assessment validation for the cloud account
     */
    category: models.AssessmentCategory;

}
